import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Api from '../service/http';
import Loading from '../components/Loading';

const NewsPage = () => {
    const navigate = useNavigate();
    const { theme } = useSelector((state) => state.theme);
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getCourses = async () => {
        setIsLoading(true);
        try {
            const response = await Api.get('/app/news-list');
            setCourses([...response.data]);
        } catch (error) {
            console.error('Error fetching courses:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCourses();
    }, []);

    return (
        <div className="flex-1 flex flex-col h-full p-4 sm:p-6">
            {isLoading ? (
                <div className="flex-1 flex items-center justify-center">
                    <Loading message="Loading News..." />
                </div>
            ) : courses.length > 0 ? (
                <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                    {courses.map((course) => (
                        <div
                            key={course.id}
                            className={`border ${theme === 'dark' ? 'border-gray-700 bg-gray-800' : 'border-gray-300 bg-white'} rounded-lg p-4 shadow-sm hover:shadow-md transition cursor-pointer`}
                            onClick={() => {
                                if (course?.url) {
                                    window.open(course.url, '_blank');
                                }
                            }}
                        >
                            <img
                                src={course.image}
                                alt={course.name}
                                className="w-full h-48 object-cover rounded-md"
                            />
                            <h3 className={`text-lg font-semibold mt-4 ${theme === 'dark' ? 'text-white' : ''}`}>{course?.headline}</h3>
                            <div className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} line-clamp-4`}>
                                {moment.unix(course?.datetime).format('MMMM Do YYYY, h:mm:ss A')}
                            </div>
                            <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} mt-2 line-clamp-4`}>
                                {course?.summary}
                            </p>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={`flex flex-col items-center justify-center mt-16 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-500'}`}>
                    <p className="text-base font-medium">No Courses Available</p>
                </div>
            )}
        </div>
    );
};

export default NewsPage;
